//Create form data from form elements

const serialize = (form) => {
    const fData = new FormData();

    for (let i = 0; i < form.length; i++) {
        if (
            form[i].name !== 'namedItem' &&
            form[i].name !== 'item' &&
            !form[i].disabled &&
            form[i].type !== 'file' &&
            form[i].type !== 'reset' &&
            typeof form[i].name !== 'undefined' &&
            form[i].type !== 'submit' &&
            form[i].type !== 'button'
        ) {
            fData.append(form[i].name, form[i].value);
        } else if (form[i].type === 'file') {
            fData.append(form[i].name, form[i].files[0]);
        }
    }

    // fData.append('_method', 'patch');

    return fData;
};

export default serialize;
